/** ログアウト */
import CONSTANTS from "@/resources/constants.json";

export function logout(userId, redirectUrl = null) {
    const url = new URL(
        `${process.env.VUE_APP_API_DOMAIN}/api/v1/auth/logout`
    );

    let headers = {
        "Content-Type": "application/json",
        "Accept": "application/json"
    };

    const params = {
        user_id: userId
    };

    fetch(url, {
        method: "POST",
        headers: headers,
        credentials: 'include',
        body: JSON.stringify(params)
    })

        .then(response => {
            document.cookie = `${CONSTANTS.api_token_name}=; max-age=0;`;
            return response.json();
        })

        .then(() => {
            let loginUrl = '/login';
            if (redirectUrl) {
                loginUrl += `?redirect_url=${encodeURIComponent(redirectUrl)}`;
            }
            window.location.href = loginUrl;
        })

        .catch(() => {
            this.$emit('showError', `${CONSTANTS.errors.unexpected_error}`);
        })

        .finally(() => {

        });
}
